import React, { Component } from "react";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import LocationSidebar from "../components/LocationSidebar";

const bg = require("../../../../images/servicehero.png");

class HouseCleaningByronBay extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="House Cleaning Byron Bay | Professional Home Cleaners"
          description="House cleaning Byron Bay services. Reliable residential and holiday home cleaning solutions."
          keywords="house cleaning byron bay, cleaning services byron bay, residential cleaning byron bay, home cleaning byron bay, domestic cleaning byron bay, holiday home cleaning byron bay, vacation rental cleaning byron bay, weekly house cleaning byron bay, deep cleaning byron bay, move in cleaning byron bay, move out cleaning byron bay, apartment cleaning byron bay, unit cleaning byron bay, professional house cleaners byron bay, affordable house cleaning byron bay, reliable cleaners byron bay, same day cleaning byron bay, eco friendly cleaning byron bay, sanitisation cleaning byron bay, kitchen cleaning byron bay, bathroom cleaning byron bay, floor cleaning byron bay, rental property cleaning byron bay, relocation cleaning byron bay, property management cleaning byron bay, holiday rental turnover cleaning byron bay, trusted cleaning company byron bay, local cleaners byron bay, house cleaning near me byron bay, one off house cleaning byron bay"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  House Cleaning Services Byron Bay
                </h1>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <LocationSidebar activePage="/house-cleaning-byron-bay/" />
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            House Cleaning Services Byron Bay
                          </h4>
                          <p>
                            Byron Bay is known for its relaxed coastal
                            lifestyle. Keeping your home clean and fresh
                            enhances comfort and wellbeing. Our house cleaning
                            Byron Bay service provides professional cleaning
                            tailored to homeowners and holiday property owners.
                          </p>

                          <h4 className="dlab-title m-t30">
                            Regular Home Cleaning Byron Bay
                          </h4>
                          <p>We offer:</p>
                          <ul className="list-check primary">
                            <li>Weekly cleaning</li>
                            <li>Fortnightly cleaning</li>
                            <li>One off deep cleaning</li>
                          </ul>

                          <h4 className="dlab-title m-t30">
                            Holiday Home Cleaning Byron Bay
                          </h4>
                          <p>
                            Holiday properties require high standards to
                            maintain guest satisfaction. Our team ensures
                            properties are guest ready at all times, handling
                            everything from linen changes to deep sanitisation.
                          </p>

                          <h4 className="dlab-title m-t30">
                            Move In and Move Out Cleaning
                          </h4>
                          <p>
                            We provide relocation cleaning services across Byron
                            Bay, ensuring a smooth transition for both tenants
                            and property owners.
                          </p>

                          <h4 className="dlab-title m-t30">
                            Why Choose Kangaroo Shine
                          </h4>
                          <ul className="list-check primary">
                            <li>Professional cleaners</li>
                            <li>Reliable scheduling</li>
                            <li>Attention to detail</li>
                            <li>Local expertise in the Byron region</li>
                          </ul>

                          <p className="m-t30">
                            Book House Cleaning Byron Bay today. Experience a
                            spotless home without the stress.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default HouseCleaningByronBay;
